(() => {
  angular
    .module('gm.common.controllers')
    .controller('HeaderController', HeaderController);

  function HeaderController(
    GmyModal,
    GmySlideNavigation,
    btgPayments,
    btgUser
  ) {
    'ngInject';

    const vm = this;
    vm.checkMove = checkMove;
    vm.showGiftModal = showGiftModal;

    activate();

    function activate() {
      btgPayments.canSendGift().then((enabled) => {
        vm.sendGiftEnabled = enabled && btgUser.isSignUpComplete();
      });
    }

    function checkMove($event) {
      const flyout = angular.element('.notifications-flyout');
      const target = angular.element($event.target);
      if (GmySlideNavigation.isOpen()) {
        if (!flyout.find(target).length) {
          $event.preventDefault();
        }
      }
    }

    function showGiftModal() {
      return GmyModal.showModal({
        templateUrl: 'modules/payments/controllers/gift-gold/gift-gold.html',
        controller: 'GiftGoldController',
        controllerAs: 'giftGoldCtrl',
        overlayType: 'dark',
      });
    }
  }
})();
